<template>
  <header class="boss-admin-bar">
    <nav class="boss-admin-bar-nav">
      <ul class="top-bar boss-admin-bar-nav-list">
        <li class="boss-admin-bar-logo">
          <router-link
            :to="{ name: 'dashboardTop' }"
            data-test="title"
            class="boss-admin-bar-item"
          >
            <!-- ▼ロゴ -->
            <h1 class="boss-admin-title">
              <span class="boss-icon boss-icon-type" />
              {{ title }}
            </h1>
            <!-- ▲ロゴ -->
          </router-link>
        </li>
        <li class="boss-admin-bar-myaccount">
          <ul
            id="user-menu"
            class="dropdown menu align-right boss-myaccount-container"
            data-dropdown-menu
          >
            <div
              data-test="refresh-icon"
              @click="refresh"
            >
              <span
                v-tooltip="{ content: '画面の再読み込みを行います。画面の表示崩れや、新しい機能が反映されていない時に押下してください。'}"
                class="boss-icon boss-icon-redo-alt-solid pega-refresh"
              />
            </div>
            <li class="boss-myaccount-wrap">
              <a
                class="boss-myaccount-link"
                data-test="company-name"
              >{{ currentUser.companyName }}<span
                class="boss-myaccount-name"
                data-test="staff-name"
              >{{ roleLabel }} {{ currentUser.staffName }}</span>&nbsp;様</a>
              <ul class="menu boss-myaccount-menu">
                <li
                  v-if="!isCountScoutUserSimulation"
                  class="boss-myaccount-menu-item"
                >
                  <router-link
                    :to="{ name: 'settingAccountPassword' }"
                    data-test="password-edit"
                    class="boss-myaccount-menu-link"
                  >
                    パスワード変更
                  </router-link>
                </li>
                <li class="boss-myaccount-menu-item">
                  <a
                    class="boss-myaccount-menu-link width-100"
                    data-test="logout"
                    @click="logout"
                  >ログアウト</a>
                </li>
              </ul>
            </li>
            <li />
          </ul>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import Foundation from 'foundation-sites'
import jQuery from 'jquery'
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Header',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ]),
    isCountScoutUserSimulation () {
      return _.get(this.currentUser, 'permissions.isCountScoutUserSimulation')
    },
    roleLabel () {
      return _.get(this.currentUser, 'permissions.isViewAccount') ? '管理者' : ''
    }
  },
  created () {
    this.fetchStaffInfo()
  },
  mounted () {
    this.dropdownMenu = new Foundation.DropdownMenu(jQuery('#user-menu'), {
      hoverDelay: 200
    })
  },
  destroyed () {
    this.dropdownMenu.destroy()
  },
  methods: {
    ...mapActions([
      'clearVuex'
    ]),
    fetchStaffInfo () {
      this.$http.secured.get('/staff_info')
        .then(response => {
          this.$store.dispatch('setCurrentUser', { currentUser: response.data })
        })
    },
    logout () {
      this.$http.secured.post('/logout')
        .then(response => {
          this.clearVuex()
          this.$router.push({ name: 'Login' })
        })
    },
    refresh () {
      location.reload()
    }
  }
}
</script>
